export enum AuditType {
    LOGIN = 'login',
    RESET_PASSWORD = 'reset_password'
}

export interface UserAudit {
    id: number;
    email: string;
    error: string;
    createdAt: string;
    type: AuditType;
}
